import IFormElementOptions from "../../../interfaces/formElementOptionsInterfaces";
import FormElement from "../../../../formability/form_builder/models/formElements/formElement";
import DynamicFieldsElementOptions from "./dynamicFieldsElementOptions";
import {Hash} from "../../../interfaces/hashInterfaces";
import ElementContainer from "../../../../formability/form_builder/models/formElements/elementContainer";

export default class FormElementOptions extends DynamicFieldsElementOptions<FormElement, ElementContainer> implements IFormElementOptions {
  getElements: (elementContainer: ElementContainer, options?: Hash) => FormElement[];
  matcher: (formElement: FormElement) => boolean;
  getElementsDefault(elementContainer, options: Hash = {}): FormElement[] {
    return elementContainer.referenceableFormElementsDeep(options.includeRepeatables);
  };
  matcherDefault(formElement): boolean {
    return true;
  };

  constructor(config: Partial<IFormElementOptions> = {getElements: null, matcher: null}) {
    super(config);
  }

  matchElements(container: ElementContainer, q: string): FormElement[] {
    return this.getElements(container);
  }
}